<template>
  <div>
    <el-popover
      placement="top-start"
      trigger="hover"
    >
      <div v-if="content.length>0">
        <p
          v-for="item in content"
          :key="item"
          class="content"
        >{{ item }}</p>
      </div>
      <span slot="reference">{{ shortContent }}</span>
    </el-popover>
  </div>
</template>
<script>
export default {
  name: 'SoNoRender',
  props: {
    value: {
      type: String,
      default: () => ''
    },
    divider: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {}
  },
  computed: {
    content() {
      return this.value.split(this.divider)
    },
    shortContent() {
      return this.value && this.value.length > 20
        ? this.value.substr(0, 20) + '...'
        : this.value
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  margin: 0;
}
</style>
